import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface DocumentFilename {
  id: string;
  name: string;
}

/**
 * Fetches the id + name of every processed document in the matter (staged files
 * excluded). Backs the load-file-import Step 1 filename-matching UI, which computes
 * per-column match percentages client-side. Only id + name are returned, so a
 * large matter (~150k files) stays within a few MB.
 */
const useGetDocumentFilenames = (matterId: string | undefined, options: { enabled?: boolean } = {}) => {
  const { enabled = true } = options;
  const { fetchConfigGET } = useGetFetchConfig();

  const getDocumentFilenames = async (): Promise<DocumentFilename[]> => {
    const url = `${APIBaseChronos}/api/matter/${matterId}/files/document-filenames`;
    const response = await fetch(url, fetchConfigGET);

    if (!response.ok) {
      throw new Error(`Failed to fetch document filenames: ${response.status} ${response.statusText}`);
    }

    return response.json();
  };

  return useQuery([QueryEntity.DocumentFilenames, { matterId }], getDocumentFilenames, {
    enabled: enabled && !!matterId,
    refetchOnWindowFocus: false,
  });
};

export default useGetDocumentFilenames;
